export function useSubscribe() {
  return Promise.resolve();
}

function PushNotificationProvider() {
  return null;
}

export default PushNotificationProvider;
